/*jshint esversion: 6 */
import axios from 'axios';
import * as funcs from "../utils/showFuncs.js";
import * as ppFuncs from "../utils/PageParagraphFuncs.js";

import apiRouteNames from "../API_routes/routeFuncs";
const postManusesUrl = apiRouteNames.manusRoute;

const putSuccessET = "Faili uundamine õnnestus! ";

const putErrorET = "Faili uundamine ei õnnestunud. ";
const postErrorET = "Faili pärimine ei õnnestunud. ";
const getErrorET = "Faili pärimine ei õnnestunud. ";
const deleteErrorET = "Faili kustutamine ei õnnestunud. ";

export function getManusByIdArray(pIdArray, pargobj) {
    //console.log("------------------------------getParagraphById GET PARAGRAPHS", pId);
    axios.post( postManusesUrl + 'many', {ids: pIdArray})
        .then(function (response) {
            var allData = response.data;
            //console.log("GET PARAGRAPHS ARRAY pIdArray", allData);
            pargobj.manusObjects = allData;
        })
        .catch(function (error) {
            //console.log('GET PARAGRAPHS error', error);
            funcs.showError(getErrorET + error);
        });
}


export function getAllManus(self) {
    axios.get( postManusesUrl)
        .then(function (response) {
            var allManusesData = response.data;
            self.setState ({
                manuses: allManusesData
            } );
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}


// WEBPACK FOOTER //
// ./src/Controllers/ManusGetter.js